import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosConfig from '../../../configs/axios.config';
import axios from 'axios'

//Reducer Thunk
export const getItemMasterData = createAsyncThunk('MasterData/GetItemMasterData', async () => {
    try {
        const response = await axios.create(axiosConfig).get('api/MasterData/ItemMasterData')
        if (response.data.success) {
            return response.data.result
        }
        else {
            console.log(response.data)
        }
    }
    catch (error) {
        console.log(error)
    }
})

export const getBPMasterData = createAsyncThunk('MasterData/GetBPMasterData', async () => {
    try {
        const response = await axios.create(axiosConfig).get('api/MasterData/BPMasterData')
        if (response.data.success) {
            return response.data.result
        }
        else {
            console.log(response.data)
        }

    }
    catch (error) {
        console.log(error)
    }
})

export const getListPro4 = createAsyncThunk('MasterData/getListPro4', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/MasterData/GetBytable`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

export const getListPro2 = createAsyncThunk('MasterData/getListPro2', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/MasterData/GetBytable`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

export const getAuthWhs = createAsyncThunk('MasterData/getAuthWhs', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/MasterData/GetAuthWhs`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

const MasterDataSlice = createSlice({
    name: 'MasterData',
    initialState: {
        itemMasterData: [],
        bpMasterData: [],
        authWhs: [],
        listPro2: [],
        listPro4: [],
        itemLoading: true,
        bpLoading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getBPMasterData.fulfilled, (state, action) => {
            state.bpLoading = false
            state.bpMasterData = action.payload
        })
        builder.addCase(getItemMasterData.fulfilled, (state, action) => {
            state.itemLoading = false
            state.itemMasterData = action.payload
        })
        builder.addCase(getListPro2.fulfilled, (state, action) => {
            state.itemLoading = false
            state.listPro2 = action.payload
        })
        builder.addCase(getListPro4.fulfilled, (state, action) => {
            state.itemLoading = false
            state.listPro4 = action.payload
        }) 
        builder.addCase(getAuthWhs.fulfilled, (state, action) => {
            state.itemLoading = false
            state.authWhs = action.payload
        })
    }
})

//Reducer
const MasterDataReducer = MasterDataSlice.reducer

//Selector
export const MasterDataSelector = (state) => state.MasterDataReducer

//Action export
export const {

} = MasterDataSlice.actions

//Export reducer
export default MasterDataReducer